export async function indexPickupAddressesUseCase(client_id, pickupAddressRepository) {
    const result = await pickupAddressRepository.index(client_id);

    result.forEach( x => {
        x = new pickupAddressRepository.model(x);

        if(!x.isValid()) {
            throw new Error("Pickup Address inválido");
        }
    })

    return result;
}